import { useEffect } from 'react';
import { logEvent } from '../../lib/shared/event-logger';

function useViewedTracking(isReady = true) {
    useEffect(() => {
        if (!isReady) return;

        const elements = document.querySelectorAll('[data-viewed-event]');

        if (!elements.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const eventName = entry.target.dataset.viewedEvent;
                        const propsStr = entry.target.dataset.viewedProps;
                        const props = propsStr ? JSON.parse(propsStr) : {};

                        logEvent(eventName, props);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.5 }
        );

        elements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, [isReady]);
}

export { useViewedTracking };
